/**
 * Türkçe.
 *
 * Kept in its own file rather than inline with ru and en: a bundle is three
 * hundred strings, and four of them in one module is a file nobody can find
 * anything in. Keys must match en exactly — anything missing falls back to
 * English rather than showing the key.
 */
export const tr = {
  'app.name': 'Pine',
  'app.tagline': 'Sunucusuz mesajlaşma',
  'nav.chats': 'Sohbetler',
  'nav.channels': 'Kanallar',
  'nav.contacts': 'Kişiler',
  'nav.settings': 'Ayarlar',

  'onboard.welcome': 'Pine’a hoş geldiniz',
  'onboard.lede': 'Mesajlar doğrudan cihazlar arasında gider. Hesap yok, telefon numarası yok, yazışmanızı tutan bir sunucu yok.',
  'onboard.create': 'Profil oluştur',
  'onboard.restore': 'Kurtarma anahtarım var',
  'onboard.name': 'Size nasıl hitap edelim?',
  'onboard.namePlaceholder': 'Ad veya takma ad',
  'onboard.username': 'Bir kullanıcı adı seçin',
  'onboard.usernameLede': 'İnsanlar sizi uzun anahtarlar olmadan böyle bulur. Atlayıp sonra da belirleyebilirsiniz.',
  'onboard.usernameSkip': 'Atla',
  'access.title': 'Son bir adım: izinler',
  'access.lede': 'Android, bakmadığı uygulamaları uykuya alır. Bu izinler olmadan aramalar ve mesajlar yalnızca Pine ekranda açıkken gelir.',
  'access.notifications': 'Bildirimler',
  'access.notificationsWhy': 'Yoksa arama veya mesaj size hiçbir şekilde bildirilemez',
  'access.battery': 'Arka planda çalışma',
  'access.batteryWhy': 'Pil optimizasyonundan muafiyet — olmazsa bağlantı birkaç dakikada kopar',
  'access.fullScreen': 'Tam ekran arama',
  'access.fullScreenWhy': 'Gelen arama kilit ekranının üstünde görünsün diye',
  'access.allow': 'İzin ver',
  'access.done': 'Hazır',
  'access.anyway': 'Bunsuz devam et',
  'access.needNotifications': 'Devam etmek için bildirimler gerekli: yoksa uygulama sizi aramadan haberdar edemez.',
  'access.partial': 'Bazı izinler verilmedi — uygulama kapalıyken aramalar gelmeyebilir. Bunları sonra Ayarlar\'dan verebilirsiniz.',
  'onboard.continue': 'Devam',
  'onboard.keyTitle': 'Kurtarma anahtarınızı saklayın',
  'onboard.keyLede': 'Profilinize başka bir cihazdan dönmenin tek yolu budur. Kimse sıfırlayamaz — kopyasını tutan bir sunucu yok.',
  'onboard.keyCopied': 'Kurtarma anahtarı kopyalandı',
  'onboard.keySaved': 'Kaydettim',
  'onboard.restoreTitle': 'Profili geri yükle',
  'onboard.restoreLede': 'Profili oluştururken kaydettiğiniz kurtarma anahtarını girin.',
  'onboard.restoreAction': 'Geri yükle',
  'onboard.back': 'Geri',

  'chats.title': 'Sohbetler',
  'chats.search': 'Ara',
  'chats.empty': 'Burada henüz bir şey yok',
  'chats.emptyHint': 'Bir grup ya da kanal kurun veya Pine kimliğiyle özel sohbet başlatın.',
  'chats.all': 'Tümü',
  'chats.unread': 'Okunmamış',
  'chats.groups': 'Gruplar',
  'chats.channels': 'Kanallar',
  'chats.direct': 'Özel',
  'chats.archived': 'Arşiv',
  'chats.saved': 'Kaydedilenler',
  'restore.title': 'Yazışma henüz yüklenmedi',
  'link.addDevice': 'Başka bir cihazdaki QR ile giriş yap',
  'link.title': 'QR ile giriş',
  'link.lede': 'Zaten giriş yaptığınız cihazda Ayarlar → Cihazlar → Cihaz ekle bölümünü açın ve bu kodu okutun.',
  'link.orCode': 'Ya da kodu kopyalayıp oraya yapıştırın:',
  'link.waiting': 'Onay bekleniyor…',
  'link.expired': 'Kodun süresi doldu. Yeniden deneyin.',
  'devices.title': 'Cihazlar',
  'devices.empty': 'Şimdilik yalnızca bu cihaz.',
  'devices.unnamed': 'Cihaz',
  'devices.current': 'bu cihaz',
  'devices.revoke': 'Bağlantıyı kes',
  'devices.revoked': 'Cihazın bağlantısı kesildi',
  'devices.add': 'Cihaz ekle',
  'devices.addHint': 'Yeni cihazdaki QR kodu okutun',
  'devices.addAction': 'Devam',
  'devices.scanLede': 'Kamerayı yeni cihazın gösterdiği QR koduna tutun.',
  'devices.pasteLabel': 'Ya da o cihazdaki kodu yapıştırın',
  'devices.linked': 'Cihaz eklendi',
  'devices.linking': 'Gönderiliyor…',
  'devices.confirmTitle': 'Hesap bu cihaza verilsin mi?',
  'devices.confirmBody': 'Hesabınıza ve içindeki her şeye tam erişimi olur. Bunu yalnızca cihaz sizinse ve kodu gösteren oysa yapın.',
  'devices.confirmAction': 'Devret',
  'devices.warning': 'Bağlantıyı kesmek cihazı listeden çıkarır ve dürüst bir istemci kendini oturumdan atar. Ama hesap anahtarı zaten onda — cihaz başkasının elindeyse, gerçekten geri almanın tek yolu yeni bir hesap.',
  'restore.action': 'Geri yükle',
  'restore.asking': 'Katılımcılara soruluyor…',
  'restore.asked': 'Soruldu: {n}',
  'restore.nobodyOnline': 'Katılımcıların hiçbiri çevrimiçi değil. Sonra tekrar deneyin.',
  'restore.hint': 'Ad ve katılımcılar sunucudan geldi. Yazışmayı katılımcıların kendisi verir.',
  'restore.section': 'Geri yükleme',
  'restore.sectionHint': 'Bu cihazda eksik olanı katılımcılardan isteyin: geçmişi ya da yazma hakkını.',
  'restore.nothingMissing': 'Bu sohbette eksik bir şey yok',
  'attach.title': 'Ekle',
  'attach.media': 'Fotoğraf ve video',
  'attach.music': 'Müzik',
  'attach.documents': 'Belgeler',
  'attach.files': 'Dosyalar',
  'attach.poll': 'Anket',
  'attach.unreadable': 'Şu kadar dosya okunamadı: {n}',
  'attach.pickerFailed': 'Dosya seçici açılamadı',
  'poll.title': 'Yeni anket',
  'poll.question': 'Soru',
  'poll.questionPlaceholder': 'Ne soruyorsunuz?',
  'poll.options': 'Yanıtlar',
  'poll.optionPlaceholder': 'Yanıt',
  'poll.optionMore': 'Yanıt ekle',
  'poll.optionsHint': 'Yeni satır kendiliğinden gelir. Enter bir sonrakine geçer.',
  'poll.limit': 'Bir ankette bundan fazla yanıt olamaz.',
  'poll.anonymous': 'Gizli oylama',
  'poll.multiple': 'Birden çok yanıt',
  'poll.anonymousNote': 'Gizli anket',
  'poll.noVotes': 'Henüz oy yok',
  'poll.create': 'Oluştur',
  'chats.you': 'Siz',
  'chats.draft': 'Taslak',

  'new.title': 'Yeni sohbet',
  'new.group': 'Grup',
  'new.groupHint': 'Herkesin yazabildiği ortak sohbet',
  'new.channel': 'Kanal',
  'new.channelHint': 'Yöneticiler yayımlar, diğerleri okur',
  'new.direct': 'Özel sohbet',
  'new.directHint': 'Pine kimliğiyle bire bir',
  'new.join': 'Bağlantıyla katıl',
  'new.joinHint': 'Daveti yapıştırın',
  'new.name': 'Ad',
  'new.namePlaceholder': 'Örneğin, Pine ekibi',
  'new.description': 'Açıklama',
  'new.create': 'Oluştur',
  'new.peerId': 'Karşı tarafın Pine kimliği',
  'new.start': 'Başlat',
  'new.invitePlaceholder': 'https://papi.olshub.xyz/i/… ya da kod',

  'conv.placeholder': 'Mesaj',
  'conv.placeholderChannel': 'Kanala yaz',
  'conv.readOnly': 'Burada yalnızca yöneticiler yazabilir',
  'conv.notWritable': 'Bu odaya yazma izni bekleniyor…',
  'conv.askAccess': 'Tekrar iste',
  'conv.queueing': 'Sohbet bu cihazı henüz onaylıyor. Yazabilirsin: mesajların, katılımcılardan biri çevrimiçi olur olmaz gider.',
  'settings.contactDev': 'Geliştiriciye yaz',
  'settings.contactDevHint': 'Sorular, hatalar, öneriler',
  'contactDev.lede': 'Sorular, hatalar ve öneriler için geliştiriciye e-posta gönderin:',
  'contactDev.copy': 'Adresi kopyala',
  'contactDev.write': 'E-posta yaz',
  'stories.mute': 'Sesi kapat',
  'stories.unmute': 'Sesi aç',
  'conv.sending': 'Gönderiliyor…',
  'bot.label': 'bot',
  'bot.start': 'Başlat',
  'bot.commands': 'Bot komutları',
  'bot.addToGroup': 'Gruba ekle',
  'bot.addTitle': '{name} adlı botu gruba ekle',
  'bot.add': 'Ekle',
  'bot.added': '“{name}” daveti gönderildi',
  'bot.addFailed': 'İletilemedi: alıcı şu anda çevrimdışı. Bunun yerine davet bağlantısı gönderebilirsiniz.',
  'bot.noGroups': 'Davet edebileceğiniz grup yok',
  'assistant.subtitle': 'Yapay zekâ asistanı',
  'assistant.denied': 'Yapay zekâ asistanını kullanmak için geliştiriciye başvurun.',
  'assistant.copyId': 'Pine kimliğimi kopyala',
  'assistant.idCopied': 'Pine kimliği kopyalandı — geliştiriciye gönderin',
  'assistant.connecting': 'Anya katılıyor — sohbet birkaç saniye içinde hazır olacak.',
  'action.send': 'Gönder',
  'stories.me': 'Ben',
  'stories.mine': 'Hikâyem',
  'stories.add': 'Hikâye ekle',
  'stories.title': 'Yeni hikâye',
  'stories.caption': 'Açıklama — isteğe bağlı',
  'stories.publish': 'Paylaş',
  'stories.published': 'Hikâye 24 saatliğine paylaşıldı',
  'stories.failed': 'Paylaşılamadı',
  'stories.audience': 'Birebir sohbetin olan herkes görecek. 24 saat sonra kaybolur. Pine sunucusu onu yalnızca şifreli olarak saklar.',
  'stories.tooBig': 'Dosya çok büyük: hikâyeler en fazla 24 MB olabilir',
  'stories.tooLong': 'Hikâye videosu en fazla bir dakika olabilir',
  'stories.unsupported': 'Hikâye bir fotoğraf ya da video olabilir',
  'stories.unreadable': 'Bu fotoğraf açılamadı',
  'stories.reply': 'Yanıtla…',
  'stories.sent': 'Sohbete gönderildi',
  'stories.play': 'Oynat',
  'stories.pause': 'Duraklat',
  'stories.gone': 'Bu hikâye artık mevcut değil',
  'stories.viewsTitle': 'Görüntülenme: {n}',
  'stories.noViews': 'Henüz kimse izlemedi',
  'stories.delete': 'Sil',
  'stories.deleteConfirm': 'Bu hikâye herkes için silinsin mi?',
  'stories.deleted': 'Hikâye silindi',
  'stories.replyHeader': 'Hikâyeye yanıt',
  'stories.reactedHeader': 'Hikâyeye tepki',
  'badge.bot': 'Bot',
  'contacts.inviteTo': 'sizi “{name}” grubuna davet ediyor',
  'conv.empty': 'Burada henüz mesaj yok',
  'conv.emptyHint': 'İlkini siz yazın — doğrudan diğer katılımcılara gider.',
  'conv.awaitingPeer': 'Davet yolda. {name} Pine’ı açtığında bu sohbeti görecek — şimdiden yazabilirsiniz.',
  'conv.thatPerson': 'Karşı taraf',
  'conv.selectChat': 'Bir sohbet seçin',
  'conv.selectChatHint': 'Ya da sohbet listesinin üstündeki «+» düğmesiyle yeni bir tane başlatın.',
  'chats.noMessages': 'Henüz mesaj yok',
  'conv.edited': 'düzenlendi',
  'conv.deleted': 'Mesaj silindi',
  'conv.attachmentGone': 'Bu dosya artık kimsede yok',
  'media.loading': 'Yükleniyor…',
  'media.waiting': 'Gönderen çevrimiçi olunca gelecek',
  'media.tapToLoad': 'İndirmek için dokunun',
  'invite.group': 'Grup daveti',
  'invite.channel': 'Kanal daveti',
  'invite.unnamed': 'Adsız',
  'invite.join': 'Katıl',
  'invite.subscribe': 'Abone ol',
  'collect.title': 'Koleksiyon kullanıcı adı',
  'collect.kind': 'Pine operatörü tarafından verildi · süresi dolmaz',
  'collect.explain': 'Kullanıcı adınız olur. Yenilenmesi gerekmez ve başkası alamaz.',
  'collect.replaces': 'Mevcut adınız {name} serbest bırakılacak.',
  'collect.take': 'Adı al',
  'collect.done': 'Artık {name} sizsiniz',
  'collect.err.used': 'Bu bağlantı zaten kullanıldı.',
  'collect.err.unknown': 'Bağlantı geçersiz ya da ad sunucusuna ulaşılamıyor.',
  'collect.err.taken': 'Bu ad zaten alınmış.',
  'collect.err.frozen': 'Bu hesap donduruldu ve ad alamaz.',
  'collect.err.offline': 'Ad sunucusuna ulaşılamıyor. Daha sonra deneyin.',
  'collect.err.failed': 'Ad alınamadı.',
  'settings.linkPreviews': 'Bağlantı önizlemeleri',
  'settings.linkPreviewsHint': 'Mesajda bağlantının başlığı ve resmi. Sayfayı Pine sunucusu getirir — adresi öğrenir, sohbeti veya alıcıyı değil.',
  'conv.reply': 'Yanıtla',
  'conv.edit': 'Düzenle',
  'conv.delete': 'Sil',
  'conv.copy': 'Metni kopyala',
  'conv.forward': 'İlet',
  'conv.pin': 'Sabitle',
  'conv.unpin': 'Sabitlemeyi kaldır',
  'conv.replyTo': 'Yanıt',
  'conv.editing': 'Düzenleme',
  'conv.pinned': 'Sabitlenmiş',
  'conv.jumpToLatest': 'Sonuncuya git',
  'conv.loadOlder': 'Daha eskileri göster',
  'conv.deleteConfirm': 'Bu mesaj herkesten silinsin mi?',
  'conv.deleteForAll': 'Herkesten sil',
  'conv.cancel': 'Vazgeç',
  'conv.typing': 'yazıyor…',
  'conv.typingMany': 'yazıyorlar…',
  'conv.online': 'çevrimiçi',
  'conv.membersOnline': '{online} çevrimiçi',
  'conv.recording': 'Sesli mesaj kaydediliyor',
  'emoji.search': 'Emoji ara',
  'emoji.none': 'Bir şey bulunamadı',
  'emoji.cat.recent': 'Son kullanılanlar',
  'emoji.cat.smileys': 'Yüzler ve duygular',
  'emoji.cat.people': 'İnsanlar ve el hareketleri',
  'emoji.cat.nature': 'Hayvanlar ve doğa',
  'emoji.cat.food': 'Yiyecek ve içecek',
  'emoji.cat.travel': 'Seyahat ve yerler',
  'emoji.cat.activities': 'Etkinlikler',
  'emoji.cat.objects': 'Nesneler',
  'emoji.cat.symbols': 'Semboller',
  'conv.slideToCancel': 'Göndermek için bırakın',

  'sys.join': '{name} sohbete katıldı',
  'sys.leave': '{name} sohbetten ayrıldı',
  'sys.kick': '{name} sohbetten çıkarıldı',
  'sys.role': '{name} artık {role}',
  'sys.callEnded': 'Arama, {duration}',
  'sys.callMissed': 'Cevapsız arama',
  'sys.callNoAnswer': 'Yanıtlanmayan arama',
  'sys.callDeclined': 'Arama reddedildi',

  'panel.info': 'Bilgi',
  'panel.members': 'Katılımcılar',
  'panel.media': 'Medya',
  'panel.files': 'Dosyalar',
  'panel.links': 'Bağlantılar',
  'panel.invite': 'Davet',
  'panel.inviteLink': 'Davet bağlantısı',
  'panel.newInvite': 'Bağlantı oluştur',
  'panel.copyLink': 'Bağlantıyı kopyala',
  'panel.revoke': 'İptal et',
  'panel.notifications': 'Bildirimler',
  'panel.mute': 'Sessize al',
  'panel.pinChat': 'Sohbeti sabitle',
  'panel.archive': 'Arşivle',
  'panel.leave': 'Sohbetten ayrıl',
  'panel.leaveConfirm': 'Sohbetten ayrılınsın mı? Geçmiş bu cihazda kalır.',
  'panel.permissions': 'Yetkiler',
  'panel.readOnly': 'Yalnızca okuma',
  'panel.membersCanInvite': 'Katılımcılar davet edebilir',
  'panel.reactions': 'Tepkiler',
  'panel.disappearing': 'Kaybolan mesajlar',
  'panel.noMedia': 'Henüz medya yok',
  'panel.makeAdmin': 'Yönetici yap',
  'panel.makeModerator': 'Moderatör yap',
  'panel.makeMember': 'Katılımcı yap',
  'panel.removeMember': 'Sohbetten çıkar',
  'panel.copyId': 'Pine kimliğini kopyala',

  'role.owner': 'Sahip',
  'role.admin': 'Yönetici',
  'role.moderator': 'Moderatör',
  'role.member': 'Katılımcı',
  'role.restricted': 'Kısıtlı',

  'frozen.title': 'Bu hesap donduruldu.',
  'frozen.body': 'Yönetim hesabı kısıtladı: yeni sohbet başlatamaz ve yeni sohbetlere katılamazsınız, sizi kimse bulamaz. Mevcut tüm sohbetleriniz her zamanki gibi çalışır.',
  'frozen.self': 'Hesap donduruldu: yeni sohbet başlatılamaz. Mevcut sohbetler çalışmaya devam eder.',
  'frozen.peer': 'Bu hesap dondurulmuş — onunla yeni bir sohbet başlatılamaz.',

  'report.title': 'Şikâyet et',
  'report.action': 'Şikâyet et',
  'report.user': 'Bu kişiyi şikâyet et',
  'report.userSub': 'Yazışma desteğe gönderilir',
  'report.reason': 'Sebep',
  'report.reason.spam': 'Spam',
  'report.reason.abuse': 'Hakaret veya tehdit',
  'report.reason.fraud': 'Dolandırıcılık',
  'report.reason.illegal': 'Yasak içerik',
  'report.reason.other': 'Başka bir şey',
  'report.note': 'Ne oldu',
  'report.notePlaceholder': 'İsteğe bağlı, ama yardımcı olur',
  'report.send': 'Şikâyeti gönder',
  'report.sent': 'Şikâyet gönderildi',
  'report.failed': 'Şikâyet gönderilemedi. Daha sonra deneyin.',
  'report.sendsMessage': 'Sunucuya bu mesaj, Pine kimliğiniz ve sebep gider — başka hiçbir şey.',
  'report.sendsChat': 'Bu sohbetin son 100 mesajı düz metin olarak sunucuya gönderilir ve yöneticiler bunu okuyabilir. Normalde bir Pine sohbetini içindekilerden başkası göremez; bu tek istisnadır ve yalnızca siz bu düğmeye bastığınızda olur.',

  'settings.title': 'Ayarlar',
  'settings.profile': 'Profil',
  'avatar.change': 'Fotoğrafı değiştir',
  'avatar.remove': 'Fotoğrafı kaldır',
  'avatar.updated': 'Fotoğraf güncellendi',
  'avatar.failed': 'Bu görsel işlenemedi',
  'avatar.notImage': 'Bu bir görsel değil',
  'badge.verified': 'Doğrulanmış hesap',
  'badge.tester': 'Beta test eden',
  'badge.donor': 'Projeyi destekledi',
  'badge.translator': 'Çevirmen',
  'settings.badges': 'Rozetler',
  'settings.badgeAlways': 'Her zaman görünür',
  'settings.badgesHint': 'Rozetler adınızın yanında başkalarına görünür. Sunucuyu işletenler verir; doğrulama dışındaki her rozeti kapatabilirsiniz — doğrulama, kimsenin sizi taklit edememesi için vardır.',
  'settings.badgeFailed': 'Kaydedilemedi — sunucuya ulaşılamıyor',
  'settings.badgeRefused': 'Kaydedilemedi: sunucu isteği reddetti',
  'settings.name': 'Ad',
  'settings.bio': 'Hakkında',
  'settings.username': 'Kullanıcı adı',
  'settings.usernameHint': 'Uzun kimlik yerine @ad ile sizi bulabilirler.',
  'settings.usernamePlaceholder': 'örneğin, alex',
  'settings.usernameFree': 'Ağda duyuruluyor',
  'settings.usernameNone': 'Belirlenmedi',
  'name.err.emoji': 'İsimde emoji kullanılamaz',
  'username.err.short': 'En az 3 karakter',
  'username.err.long': 'En fazla 32 karakter',
  'username.err.charset': 'Yalnızca latin harf, rakam ve alt çizgi',
  'username.err.underscore': 'Alt çizgiyle başlayamaz ve bitemez',
  'username.err.empty': 'Bir ad girin',
  'username.err.taken': 'Bu ad alınmış — başka deneyin',
  'username.err.offline': 'Ad sunucusuna ulaşılamıyor. Sonra tekrar deneyin.',
  'username.err.failed': 'Bu ad alınamadı',
  'username.err.stale': 'Bu cihazın saati yanlış — saati kontrol edin',
  'username.err.slow_down': 'Çok fazla deneme. Bir dakika bekleyin.',
  'settings.usernameTaken': 'Alınmış',
  'settings.usernameChecking': 'Kontrol ediliyor…',
  'settings.usernameReserved': 'Size ayrıldı',
  'search.byUsername': '@ad ya da Pine kimliğiyle ara',
  'search.searching': 'Aranıyor…',
  'search.notFound': 'Bu ada kimse yanıt vermiyor. Çevrimdışı olabilir.',
  'search.found': 'Bulundu',
  'search.collision': 'Bu adı birden fazla kişi duyurdu. Kimlikleri kontrol edin.',
  'search.hint': 'Bir ad tek bir kişiye aittir. Ad sunucusuna ulaşılamazsa arama ağa döner ve birkaç sonuç bulabilir.',
  'contacts.username': 'Kullanıcı adı',
  'settings.yourId': 'Pine kimliğiniz',
  'settings.idHint': 'Size yazmak isteyen herkese bunu verin.',
  'settings.appearance': 'Görünüm',
  'settings.theme': 'Tema',
  'settings.themeSystem': 'Sistemle aynı',
  'settings.themeLight': 'Açık',
  'settings.themeDark': 'Koyu',
  'settings.language': 'Dil',
  'settings.notifications': 'Bildirimler',
  'settings.notificationsGroup': 'Bildirimler ve sesler',
  'settings.chatsGroup': 'Sohbetler ve medya',
  'settings.keysGroup': 'Anahtar ve çıkış',
  'settings.notificationsCalls': 'Bildirimler ve aramalar',
  'settings.chatsAppearance': 'Sohbetler ve görünüm',
  'settings.privacySecurity': 'Gizlilik ve güvenlik',
  'settings.bgAttention': 'Aramalar size ulaşmayabilir: izinleri kontrol edin',
  'settings.notificationsOn': 'Bildirimleri göster',
  'settings.sound': 'Ses',
  'settings.autostart': 'Bilgisayarla birlikte başlat',
  'settings.autostartHint': 'Bir bilgisayar, telefon gibi sunucudan uyandırılamaz: mesajlar ve aramalar yalnızca Pine çalışırken gelir. Pencere açmadan sistem tepsisinde başlar.',
  'settings.privacy': 'Gizlilik',
  'settings.readReceipts': 'Okundu bilgisi',
  'settings.typingIndicators': 'Yazıyor bilgisini paylaş',
  'settings.enterToSend': 'Enter mesajı gönderir',
  'settings.autoDownload': 'Medyayı otomatik indir',
  'settings.backupKeys': 'Sohbetleri yedekle',
  'settings.backupKeysHint': 'Sohbet anahtarları sunucuda şifreli durur, böylece yeni cihaz sohbetlerini hemen bulur. Kapatırsanız anahtarlar katılımcılardan istenir.',
  'settings.calls': 'Aramalar',
  'settings.telecom': 'Android sistem aramaları',
  'settings.telecomHint': 'Aramalar telefonun kendi arama hizmetinden geçer: daha güvenilir gelir, kulaklıktan ve araçtan cevaplanabilir. Telefonunuzda sorun çıkarırsa kapatın.',
  'pro.home': 'Anya için daha fazla model ve daha yüksek sınırlar',
  'pro.active': '{date} tarihine kadar etkin',
  'pro.ended': '{date} tarihinde sona erdi',
  'pro.inactive': 'Etkin değil',
  'pro.unavailable': 'Sunucu şu anda yanıt vermiyor, daha sonra deneyin',
  'pro.what': 'Neler sunar',
  'pro.plain': 'Standart',
  'pro.perDay': 'Günlük soru',
  'pro.perMonth': 'Aylık soru',
  'pro.images': 'Günlük resim',
  'pro.models': 'Ek modeller',
  'pro.get': 'Abone ol',
  'pro.extend': 'Uzat',
  'pro.howTo': 'Aboneliği geliştirici açar. Düğmeye basın: mektupta Pine ID’niz zaten olacak. Size nasıl ödeyeceğiniz söylenir ve Pro açılır.',
  'pro.contactLede': 'Geliştiriciye Pine AI Pro istediğinizi yazın. Size nasıl ödeyeceğiniz söylenir ve abonelik Pine ID’niz için açılır.',
  'pro.contactBody': 'Merhaba! Pine AI Pro almak istiyorum.',
  'settings.ringFromPush': 'Doğrudan sunucu üzerinden çal',
  'settings.ringFromPushHint': 'Telefon, sunucu aramayı iletir iletmez çalar, arayanla bağlantıyı beklemez. Sunucu ve Google bu durumda sizi kimin aradığını görür (yalnızca kimlik, konuşma değil).',
  'settings.ringtone': 'Zil sesi',
  'settings.ringtonePine': 'Pine',
  'settings.ringtoneSystem': 'Cihazdaki gibi',
  'settings.ringtonePick': 'Cihazdan seç…',
  'settings.background': 'Arka planda çalışma',
  'settings.backgroundHint': 'Aramalar ve mesajlar yalnızca Pine arka planda çalışırken gelir. Bunlardan biri izinli değilse gelen aramalar size ulaşmayabilir.',
  'settings.push': 'Pine kapalıyken uyandır',
  'settings.pushHint': 'Sunucu Google üzerinden boş bir sinyal gönderir — "arama" ya da "yeni bir şey var" — ve Pine uyanıp her şeyi kendisi, şifreli olarak alır. Sinyalde ne metin ne gönderen vardır. Kapatırsanız kapalı uygulama yeniden açılana kadar hiçbir şey almaz.',
  'web.notifyTitle': 'Tarayıcı bildirimleri',
  'web.notifyHint': 'Aramalar ve mesajlar — Pine sekmesi kapalıyken bile',
  'web.notifyBlocked': 'Tarayıcıda engellendi',
  'web.notifyOn': 'Bildirimler açık',
  'web.notifyBanner': 'Bildirimleri açın — yoksa kapalı sekme aramadan haberdar olmaz.',
  'web.notifyInstall': 'iPhone\'da bildirimler yalnızca Ana Ekran\'daki Pine\'a gelir: Paylaş → Ana Ekrana Ekle, sonra Pine\'ı oradan açın.',
  'web.installRelogin': 'Orada bir kez daha giriş yapmanız gerekir: Safari ve Ana Ekran simgesi verileri ayrı tutar. Simgedeki Pine\'da «Başka bir cihazdaki QR ile giriş yap»ı seçin, kodu kopyalayın ve buraya yapıştırın: Ayarlar → Cihazlar → «Cihaz ekle».',
  'keysave.save': 'Anahtarı tarayıcıya kaydet',
  'keysave.signIn': 'Kayıtlı anahtarla giriş yap',
  'keysave.fill': 'Tarayıcıdaki anahtarı kullan',
  'settings.bgNotifications': 'Bildirimler',
  'settings.bgBattery': 'Pil kısıtlaması yok',
  'settings.bgFullScreen': 'Tam ekran arama',
  'settings.bgAllowed': 'İzinli',
  'settings.bgFix': 'İzin ver',
  'settings.bgUnrestricted': 'Arka plan etkinliği kısıtlanmamış',
  'settings.bgJournal': 'Arka plan günlüğü',
  'settings.bgJournalHint': 'Bir arama ulaşmadıysa günlüğü geliştiriciye gönderin. İçinde yalnızca olayların zamanları var, yazdıklarınız yok.',
  'settings.bgJournalSend': 'Gönder',
  'settings.network': 'Ağ',
  'settings.connection': 'Bağlantı',
  'settings.peers': 'Bağlı eşler',
  'settings.mode': 'Mod',
  'settings.modeNative': 'Doğrudan eşler arası',
  'settings.modeRelay': 'Aktarıcı üzerinden',
  'settings.account': 'Profil ve anahtarlar',
  'settings.recoveryKey': 'Kurtarma anahtarı',
  'settings.showKey': 'Anahtarı göster',
  'settings.hideKey': 'Gizle',
  'settings.storage': 'Depolama',
  'settings.about': 'Hakkında',
  'settings.signOut': 'Çıkış yap',
  'settings.signOutHint': 'Bu hesabı bu cihazdan sil',
  'settings.signOutConfirm': 'Çıkış yap ve sil',
  'settings.signOutWarning': 'Pine hesabı yalnızca bu cihazda yaşar — hiçbir sunucu onu tutmaz. Çıkış yapmak profili, sohbetleri ve ayarları siler. Bu hesaba dönmenin tek yolu kurtarma anahtarıdır.',
  'settings.signOutCopyKey': 'Kurtarma anahtarını kopyala',
  'settings.signOutNeedKey': 'Devam etmek için anahtarı kopyalayın.',
  'update.title': '{version} sürümü çıktı',
  'update.sub': 'Güncelleme elle yapılır — indirme sayfasından.',
  'update.action': 'Güncelle',
  'settings.save': 'Kaydet',
  'settings.saved': 'Kaydedildi',

  'contacts.title': 'Kişiler',
  'contacts.empty': 'Henüz kişi yok',
  'contacts.emptyHint': 'Sohbet başlatmak için birini Pine kimliğiyle ekleyin.',
  'contacts.add': 'Kişi ekle',
  'contacts.requests': 'İstekler',
  'contacts.accept': 'Kabul et',
  'contacts.decline': 'Reddet',
  'contacts.block': 'Engelle',
  'contacts.unblock': 'Engeli kaldır',
  'contacts.blocked': 'Engellendi',
  'block.sub': 'Mesajlarını, isteklerini, aramalarını ve hikâyelerini gösterme',
  'block.blockedSub': 'Yeni mesajları, aramaları ve hikâyeleri gösterilmiyor',
  'block.confirm': 'Pine, {name} kişisinden gelen yeni mesajları, istekleri ve aramaları göstermeyi bırakacak, hikâyelerini gizleyecek ve seninkileri ona göndermeyecek. Bundan haberi olmayacak. Engeli istediğin zaman kaldırabilirsin.',
  'block.done': '{name} engellendi',
  'block.undone': '{name} engeli kaldırıldı',
  'block.inChat': 'Bu kişiyi engelledin. Yeni mesajları gösterilmiyor.',
  'contacts.message': 'Mesaj',
  'contacts.request': 'sohbet başlatmak istiyor',

  'call.incoming': 'Gelen arama',
  'call.incomingVideo': 'Gelen görüntülü arama',
  'call.calling': 'Aranıyor…',
  'call.connecting': 'Bağlanıyor…',
  'call.accept': 'Cevapla',
  'call.decline': 'Reddet',
  'call.hangUp': 'Bitir',
  'call.joining': 'Aramaya bağlanılıyor…',
  'call.participants': 'aramada {n} kişi',
  'call.full': 'Bu arama zaten dolu',
  'call.unreachable': 'Arama bağlanamadı. Taraflardan birinin ağı aramaları engelliyor olabilir: başka bir ağ ya da VPN deneyin.',
  'call.mute': 'Mikrofon',
  'call.camera': 'Kamera',
  'call.screen': 'Ekran',
  'call.speaker': 'Hoparlör',
  'call.speakerOn': 'Hoparlör açık',
  'call.speakerOff': 'Hoparlörü aç',
  'call.flip': 'Diğer kamera',
  'call.minimize': 'Aramayı küçült',
  'call.audioOutput': 'Ses',
  'call.route.auto': 'Otomatik',
  'call.route.earpiece': 'Telefon ahizesi',
  'call.route.speaker': 'Hoparlör',
  'call.route.bluetooth': 'Bluetooth',
  'call.route.wired': 'Kablolu kulaklık',
  'call.ended': 'Arama bitti',
  'call.unsupported': 'Bu ortamda arama yapılamıyor',

  'status.online': 'Çevrimiçi',
  'status.connecting': 'Bağlanıyor…',
  'status.reconnecting': 'Yeniden bağlanıyor…',
  'status.offline': 'Çevrimdışı',

  'time.now': 'az önce',
  'time.yesterday': 'dün',
  'time.today': 'Bugün',
  'time.yesterdayFull': 'Dün',

  'err.generic': 'Bir şeyler ters gitti',
  'err.invite': 'Bu davet okunamadı',
  'err.joinTimeout': 'Sizi içeri alacak kimse çevrimiçi değil. Bir katılımcıdan Pine’ı açmasını isteyin.',
  'err.noPeer': 'Ulaşılamadı. Karşı tarafın Pine’ı açık olmalı.',
  'err.needName': 'Lütfen bir ad girin',

  'action.copy': 'Kopyala',
  'action.copied': 'Kopyalandı',
  'action.share': 'Paylaş',
  'action.done': 'Tamam',
  'action.cancel': 'Vazgeç',
  'action.close': 'Kapat',
  'action.retry': 'Yeniden dene',
  'action.download': 'İndir',
  'action.confirm': 'Onayla'
}
